import PollControls from './PollControls';
import PollGroupControls from './PollGroupControls';

export const utils = {
  PollControls,
  PollGroupControls,
};
